import React, { Component } from "react";
import cx from "classnames";
import Img from "gatsby-image";

export default class Wherewe extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      itemScroll: 0
      // opacity: 0
    };
  }

  componentDidMount() {
    typeof window !== "undefined" &&
      window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll(event) {
    const clamp = (min, max, val) => Math.min(Math.max(min, val), max);

    const { top, height } = this.wherewe.getBoundingClientRect();

    const val = clamp(0, 1, (-top + height) / (height * 3));
    const opa = (-top + height / 2) / (height * 0.8) > 0 ? 1 : 0;

    this.setState({
      itemScroll: window.innerWidth > 736 ? val : this.state.itemScroll
      //opacity: this.state.opacity == 1 ? 1 : opa
    });
  }

  render() {
    return (
      <section className="wherewe" ref={n => (this.wherewe = n)}>
        <div className="container">
          <div className="content">
            <div className="u-center">
              <span className="o-gradhead">Where are we</span>
            </div>
            <div className="wherewe--wrap">
              <div
                className={cx("stylant", "wherewe--place", "wherewe--place1")}
                style={{
                  top: +this.state.itemScroll * 100
                }}
              >
                <div className="stylant--pic">
                  <Img
                    sizes={this.props.images.munich.childImageSharp.sizes}
                    alt="Munich"
                  />
                </div>
                <div className="stylant--title">Germany</div>
                <div className="stylant--subtitle">Munich</div>
              </div>
              <div
                className={cx("stylant", "wherewe--place", "wherewe--place2")}
                style={{
                  top: -this.state.itemScroll * 300
                }}
              >
                <div className="stylant--pic">
                  <Img
                    sizes={this.props.images.alicante.childImageSharp.sizes}
                    alt="Alicante"
                  />
                </div>
                <div className="stylant--title">Spain</div>
                <div className="stylant--subtitle">Alicante</div>
              </div>
            </div>
            <div className={cx("stylant", "wherewe--remote")}>
              <div className="stylant--title__lower">
                Most of our clients are remote
              </div>
              <div className="stylant--subtitle">
                And we are really good at working remotely
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Wherewe.js